import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { MemoizedSelector, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ActionCreatorWithProps } from 'src/app/shared/types/action-creator.type';
import { AppStore } from 'src/app/store/store.model';
import { EffectInitiator } from '../types/effect-initiator.type';

@Injectable({
  providedIn: 'root',
})
export class EffectCreatorUtilsService {
  // effects are usually triggered by actions, but they can also be triggered by selectors (or any other observable)
  // this function takes either an action or selector, and returns an observable that emits when the action
  // is dispatched or the selector emits a new value
  public createInitiatingObservable<TProps>(initiator: EffectInitiator<TProps>) {
    const isAction = (
      testInitiator: EffectInitiator<TProps>,
    ): testInitiator is ActionCreatorWithProps<TProps> =>
      (initiator as ActionCreatorWithProps<TProps>).type !== undefined;

    const isSelector = (
      testInitiator: EffectInitiator<TProps>,
    ): testInitiator is MemoizedSelector<any, TProps> =>
      (initiator as MemoizedSelector<any, TProps>).projector !== undefined;

    const isObservable = (
      testInitiator: EffectInitiator<TProps>,
    ): testInitiator is Observable<TProps> => testInitiator instanceof Observable;

    if (isAction(initiator)) {
      return this.actions$.pipe(ofType(initiator));
    } else if (isSelector(initiator)) {
      return this.store.select(initiator);
    } else if (isObservable(initiator)) {
      return initiator;
    }

    throw new Error('Invalid effect initiator');
  }

  constructor(private actions$: Actions, private store: Store<AppStore>) {}
}
